import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

/*
v-tooltip="{
  theme: 'temp'
}"
*/
export class TooltipPlugin {
  static install(Vue, _options) {
    Vue.use(FloatingVue, {
      themes: {
        overflow: {
          $extend: 'tooltip',
          triggers: []
          // Other options (see the 'Global options' section)
        },
        transient: {
          $extend: 'tooltip',
          triggers: []
        }
      }
    })
    FloatingVue.options.themes.tooltip.disabled = false
    FloatingVue.options.themes.overflow.disabled = false
    FloatingVue.options.themes.transient.disabled = false
  }
}
